import { PARENT_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { RichValue, StringValue } from '../../../value/types.tsx';
import type { TransformedParentField, TransformedParentOption } from '../types.tsx';

const getParentValue: StringValue<TransformedParentField> = (field) =>
	field.value ? field.value.issueKey : '';

export const parentStringValueHandler = {
	[PARENT_TYPE]: getParentValue,
};

const getParentRichValue: RichValue<TransformedParentField, TransformedParentOption> = (field) =>
	field.value ?? null;

export const parentRichValueHandler = {
	[PARENT_TYPE]: getParentRichValue,
};
